<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row mt-3">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-clipboard-list-check text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Servicios Compensatorios
        </span>
      </div>
    </div>
    <div class="row py-3 mr-md-0">
      <div class="col-12">
        <custom-result-not-found
          v-if="items.length === 0"
          text="No cuenta con solicitudes compensatorias"
        />
        <div v-for="(item, index) in items" :key="index">
          <contract-request-compensatory
            :collapsable="collapsable"
            :contract="contract"
            :has-actions="hasActions"
            :has-permission-closing-analysis="hasPermissionClosingAnalysis"
            :has-submit-actions="hasSubmitActions"
            :is-read-only="isReadOnly(item.statusId)"
            :item="item"
            :same-context="sameContext"
            @on-open-additional-info="onOpenAdditionalInfoTabHandler(item)"
            @on-open-close="openRequestTabHandle(item, $event)"
            @on-open-closing-analysis="onOpenClosingAnalysis(item, index)"
            @on-open-documents="onOpenDocumentsTabHandler(item)"
            @on-open-reject-request="onOpenRejectRequestHandler(item, index)"
            @on-save="onSave"
            @on-show-submit="onOpenAcceptHandler(item, index)"
            @open-request-tab="openRequestTabHandle(item, $event)"
          />
        </div>
        <pagination
          v-if="showRequestCompensatoryPagination"
          :data="pagination"
          show-text
          @pagination-go-page="goToPageHandler($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
//constants
import CustomResultNotFound from 'custom-result-not-found';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import Pagination from 'pagination';
import ContractRequestCompensatory from './tabs/ContractRequestCompensatory.vue';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus';
import viewDisplay from '@/utils/constants/compensatoryRequestView';

export default {
  name: 'ContractCompensatoryRequestResultRow',
  components: {
    CustomResultNotFound,
    Pagination,
    ContractRequestCompensatory,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
    collapsable: {
      type: Boolean,
      default: () => true,
    },
    hasSubmitActions: {
      type: Boolean,
      default: () => false,
    },
    hasActions: {
      type: Boolean,
      default: () => true,
    },
    hasPermissionClosingAnalysis: {
      type: Boolean,
      default: () => false,
    },
    contract: {
      type: Object,
      default: () => ({}),
    },
    sameContext: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      model: {},
      editingDate: false,
      showRequestCompensatoryInfo: true,
      showClosingAnalysis: false,
    };
  },
  mixins: [alertMixin],
  computed: {
    showRequestCompensatoryPagination() {
      return this.pagination.count > 0 && this.pagination.pageCount > 1;
    },
    viewDisplayEnum() {
      return viewDisplay;
    },
    analysisApply() {
      return [
        compensatoryRequestStatus.Aprobado,
        compensatoryRequestStatus.DevueltoAProveedor,
      ];
    },
    isReadOnly() {
      return (status) => {
        return !this.analysisApply.includes(status);
      };
    },
  },
  methods: {
    async goToPageHandler(page) {
      this.$emit('on-go-to-page', page);
    },
    onOpenAdditionalInfoTabHandler(item) {
      item.viewToDisplay = this.viewDisplayEnum.ADDITIONAL_INFORMATION;
    },
    onOpenDocumentsTabHandler(item) {
      item.viewToDisplay = this.viewDisplayEnum.DOCUMENTS;
    },
    onOpenRejectRequestHandler(item) {
      item.viewToDisplay = this.viewDisplayEnum.REJECT;
      this.openRequestTabHandle(item, true);
    },
    onOpenAcceptHandler(item) {
      item.viewToDisplay = this.viewDisplayEnum.ACCEPT;
      this.openRequestTabHandle(item, true);
    },
    onOpenClosingAnalysis(item, index) {
      this.$emit('on-open-closing-analysis', {
        index,
        id: item.requestId,
      });
      item.viewToDisplay = this.viewDisplayEnum.CLOSING_ANALYSIS;
    },
    openRequestTabHandle(item, $event) {
      item.isOpen = $event ?? !item.isOpen;
      if (item.viewToDisplay == this.viewDisplayEnum.CLOSING_ANALYSIS) {
        this.$emit('on-open-closing-analysis', {
          index: 0,
          id: item.requestId,
          isOpen: item.isOpen,
        });
      }
    },
    onSave() {
      this.$emit('on-save');
      this.$emit('on-go-to-page', this.pagination.currentPage);
    },
  },
};
</script>

<style lang="scss" scoped>
.status-aee {
  list-style: none;
  padding-left: 20px;
}

.status-aee li {
  margin-bottom: 5px;
  position: relative;
}

.status-aee li::before {
  content: '•';
  color: var(--bg-color);
  position: absolute;
  left: -15px;
}
</style>
